import { render } from "./statuses-tab.vue?vue&type=template&id=6e54678e"
import script from "./statuses-tab.vue?vue&type=script&lang=js"
export * from "./statuses-tab.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__